import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'corp/components/UI/IsomorphicLink/IsomorphicLink';
import { IconButton } from 'design-system';
import { copyToClipboard } from '@scale/frontend-lib/clipboard';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';
import { INamedObjectTypes } from '@scale/shared/types/lookup';
import SmartLink from 'react-scale/corp/components/SmartLink/SmartLink';

const LookupObjectLink: React.FC<{
  objectId: string;
  type?: string;
  label?: string;
  shouldOpenNewTab?: boolean;
  onClick?: () => void;
}> = props => {
  const { isRemoAdmin } = useRemoAdminCtx();
  const { objectId, label } = props;
  const newTabProps = props.shouldOpenNewTab
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};
  const toolPrefix = window.location.href.includes('/expert')
    ? '/expert/outlieradmin/tools'
    : '/remoadmin/tools';
  const lookupPrefix = isRemoAdmin ? toolPrefix : '';
  const Element = isRemoAdmin ? 'a' : Link;
  const useSmartLink =
    props.type && Object.values(INamedObjectTypes).includes(props.type as INamedObjectTypes);
  return (
    <span>
      {useSmartLink ? (
        <>
          <SmartLink type={props.type as INamedObjectTypes} id={objectId} />
          <IconButton size="small" data-tip="Open in new tab">
            <Element
              target="_blank"
              rel="noopener noreferrer"
              onClick={props.onClick}
              href={`${lookupPrefix}/lookup/${objectId}${window.location.search}`}
            >
              <FontAwesomeIcon icon="external-link-alt" color="lightgrey" />
            </Element>
          </IconButton>
        </>
      ) : (
        <Element
          {...newTabProps}
          onClick={props.onClick}
          href={`${lookupPrefix}/lookup/${objectId}${window.location.search}`}
        >
          {label ?? objectId}
        </Element>
      )}
      <IconButton
        size="small"
        data-tip="Copy to clipboard"
        onClick={() => copyToClipboard(objectId, { excludeOuterQuotes: true })}
      >
        <FontAwesomeIcon icon="copy" color="lightgrey" />
      </IconButton>
    </span>
  );
};

export default LookupObjectLink;
